import * as React from 'react';

import { SpacesLayoutIcon } from 'models';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkSpacing } from 'uitk-react-spacing';

export interface SpaceLayoutIconsProps {
  icon: SpacesLayoutIcon;
  iconSize?: UitkIconSize;
  name?: string;
}

export const SpaceLayoutIcons: React.FunctionComponent<SpaceLayoutIconsProps> = ({ icon, iconSize = UitkIconSize.MEDIUM, name }) => (
  <UitkSpacing margin={{ inlineend: 'two' }}>
    <UitkIcon key={name} name={icon.id} size={iconSize} description={icon.description} className="pwa-theme--grey-700" />
  </UitkSpacing>
);
SpaceLayoutIcons.displayName = 'SpaceLayoutIcons';
